import React from 'react';
import { Outlet } from 'react-router-dom';

const IndependentRouter: React.FC = () => {
  return <Outlet />;
};

export default IndependentRouter;
